import axios from "axios";
import { useEffect, useState } from "react";
import { useSearch } from "../../context/search";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaTimes } from "react-icons/fa";

export default function Search() {
  const [values, setValues] = useSearch();
  const [query, setQuery] = useState(values.keyword || "");
  const navigate = useNavigate();

  useEffect(() => {
    const trimmed = query.trim();

    const delay = setTimeout(async () => {
      try {
        // 🔁 IF EMPTY → LOAD ALL PRODUCTS
        if (!trimmed) {
          const { data } = await axios.get("/products");
          setValues({ ...values, keyword: "", results: data });
          return;
        }

        // 🔍 NORMAL SEARCH
        const { data } = await axios.get(`/products/search/${trimmed}`);
        setValues({ ...values, keyword: trimmed, results: data });

        navigate("/search");
      } catch (err) {
        console.log(err);
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [query]);

  return (
    <div className="search-container">

      {/* 🔍 ICON */}
      <FaSearch className="search-icon" />

      {/* INPUT */}
      <input
        type="text"
        placeholder="Search books..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="search-input"
      />

      {/* ❌ CLEAR */}
      {query && (
        <FaTimes
          className="clear-icon"
          onClick={() => setQuery("")}
        />
      )}
    </div>
  );
}